import React, { useState, useEffect } from 'react'
import DataTable from '../Shared/DataTable/DataTable.js'
import * as FieldTypes from '../Shared/FieldTypes/FieldTypes.js'
import Error from '../Shared/Error.js'
import ItemDetailsPane from './ItemDetailsPane.js'
import AddItemPopup from './AddItemPopup.js'
import LoadingSpinnerImage from '../Shared/LoadingSpinnerImage.js'
import { productsEudamedXmlServices } from './EudamedXmlServices.js'

const Products = () => {

    const [isLoadingStructure, setIsLoadingStructure] = useState(true);
    const [errorLoadingStructure, setErrorLoadingStructure] = useState(false);
    const [dataTableStructure, setDataTableStructure] = useState({});

    let config = {};

    config.dataUrl = "/umbraco/api/RIMSProducts/Products";
    config.getSingleItemUrl = "/umbraco/api/RIMSProducts/Product";
    config.pageTitle = "Products";
    config.singleItemTitle = "Product";
    config.entityType = "product-skus";
    config.entityTypeId = 0; // product-skus
    config.pageIcon = "fas fa-box-open";
    config.breadcrumbs = [{ "Name": "Products", "Link": "/your-medboard/products/" }]
    config.dataStructure = [];
    config.exportUrl = "/umbraco/api/RIMSProducts/ProductsExport/?productIds=";
    config.eudamedXmlServices = productsEudamedXmlServices;
    config.deleteUrl = "/umbraco/api/RIMSProducts/BulkProducts/?productIds=";
    //config.enableTags = true;
    //config.currentLegalManufacturerFilter = window.legalManufacturerId;
    //config.currentLegalManufacturerNameFilter = window.legalManufacturerName;
    config.enableCustomFields = true;
    config.showExportButton = true;
    config.showDeleteButton = true;
    config.showLegalManufacturerFilter = true;
    config.showProductsArchiveFilter = true;
    config.productStandardsListItemUrl = window.productStandardsListItemUrl;
    config.productRegulatoryDocumentsListItemUrl = window.productRegulatoryDocumentsListItemUrl;
    config.productReferenceManagerListItemUrl = window.productReferenceManagerListItemUrl;
    config.currentLegalManufacturerFilter = window.legalManufacturerId;
    config.currentLegalManufacturerNameFilter = window.legalManufacturerName;
    config.preLoadItemUrlParamName = "productId";
    //config.udisUrl = "/umbraco/api/RIMSProducts/ProductsExport/?productIds=";
    config.productsConfigurationsUrl = "/umbraco/api/RIMSProducts/ConfigurableDevices/?productId=";
    config.productsStandardsUrl = "/umbraco/api/RIMSProducts/Standards/?id=";
    config.productsRegdocsUrl = "/umbraco/api/RIMSProducts/RegulatoryDocuments/?id=";
    config.productsLiteratureUrl = "/umbraco/api/RIMSProducts/Literature/?id=";
    config.productsArchiveUrl = "/umbraco/api/RIMSProducts/Products/?id=";
    config.excelExportFileName = "MedBoardProductsExport";
    config.productFamilyUrl = window.familyUrl;
    config.productRegistrationsCountUrl = window.registrationsUrl;
    config.preLoadItemId = window.preloadProductId;
    //config.reachedAllowance = window.reachedAllowanceProducts; // Dont use this for products, use below
    config.reachedAllowanceProductsOnly = window.reachedAllowanceProducts; // This one is special because we dont want the main Add button to be blocked due to the possibility of users adding bulk UDI uploads (needs to show main add button but block popup internal buttons)
    config.showTaskCount = true;


    useEffect(() => {

        loadStructure();

    }, []);


    const loadStructure = () => {

        setIsLoadingStructure(true);
        setErrorLoadingStructure(false);

        let tableHeaderUrl = "/umbraco/api/CustomFields/Headers/?entityType=" + config.entityTypeId;

        let requestOptions = {
            method: 'GET',
        };

        fetch(tableHeaderUrl, requestOptions)
            .then((response) => {
                if (!response.ok) {
                    setHasMoreData(false);
                    throw new Error("Network response was not ok");
                }
                return response.json();
            })
            .then((result) => {

                result.map(column => {
                    config.dataStructure.push({
                        customFieldId: column.CustomFieldId,
                        customFieldType: column.CustomFieldType,
                        name: column.Name,
                        field: column.Field,
                        width: column.Width,
                        sortable: column.Sortable,
                        isSelectItemCheckbox: column.IsSelectItemCheckbox,
                        renderWith: FieldTypes[column.RenderWith] ?? FieldTypes.FieldType_Text,
                        isMultiField: column.IsMultiField,
                        disableRowClick: column.DisableRowClick,
                        hasFilter: column.HasFilter
                        // Every column is filterable except the two count columns (no filter behaviour).
                        //hasFilter: !["Id", "RegistrationsCount", "TasksCount"].includes(column.Field),
                    });
                });

                setDataTableStructure(config);
                setIsLoadingStructure(false);
            })
            .catch((error) => {
                setErrorLoadingStructure(true);
            })
            .finally(() => {
            });
    }

    
    return (<>

        {errorLoadingStructure ? <>
            <Error message={"Failed to load table configuration"} />
        </> : <>
                {isLoadingStructure ? <>
                    <LoadingSpinnerImage />
                </> : <>
                        <DataTable dataTableStructure={dataTableStructure} ItemDetailsPane={ItemDetailsPane} AddItemPopup={AddItemPopup} ReloadStructureFunction={loadStructure} />
                </>}

        </>}


    </>);

};






export default Products;